export const ABANDONED_CART_ROUTES = {
  abandonedCartList: '/abandoned-carts',
  abandonedCartDetails: '/abandoned-carts/:id',
};
